module.exports = __webpack_public_path__ + "static/img/Banner03.9757ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Banner03.jpg
// module id = 285
// module chunks = 2